import { request } from '../../helpers/apiHelper'
import { displayNotification } from '../../actions/notificationsActions'
import {
  productPackagesQuery,
  productPackageQuery,
  productPackageWindowQuery,
} from './queries'

export const fetchProductPackages = (varObject) => (dispatch) => {
  return request(productPackagesQuery, varObject)
    .then((response) => {
      const packages = response.data.data.productPackages.items
      const total = response.data.data.productPackages.meta.total

      const entities = packages.map((pkg, index) => {
        const userId = pkg.user.id
        return {
          ...pkg.user,
          id: `${userId}-${pkg.customerToken || pkg.id || index}`,
          originalUserId: userId,
          productPackage: pkg,
        }
      })
      
      dispatch({
        type: 'FETCH_PRODUCTPACKAGES_SUCCESS',
        entities,
        meta: { total },
      })
    })
    .catch(() => {
      dispatch({
        type: 'FETCH_PRODUCTPACKAGES_FAILURE',
      })
      dispatch(
        displayNotification('Failed to fetch Product Packages', 'error', 10000)
      )
    })
}

export const fetchProductPackage = (productPackageId) => (dispatch) => {
  return request(productPackageQuery, { id: productPackageId })
    .then((response) => {
      const { productPackage } = response.data.data

      const {
        user,
        vehicle,
        products,
        status,
        membershipId,
        selectedProductId,
        filters,
        addons,
        discount,
        organization,
        refiDetails,
        basePrice,
        validationDiscountMax,
        firstPaymentMinDays,
        firstPaymentMaxDays,
        firstPaymentMinDate,
        firstPaymentMaxDate,
        monthlyMembershipPosition,
        monthlyMembershipPositionCount,
        monthlyMembershipDiscountable,
        floridaMarkupPosition,
        floridaMarkupPositionCount,
        floridaMarkupDiscountable,
        paymentPlanProviderSource,
        addressNeeded
      } = productPackage

      const productsWithNumberId = products && products.length > 0 ? products.map((product) => {
        if (!product) return null
        const { options } = product
        const optionWithNumberId = options ? options.map((option) => ({
          ...option,
          id: Number(option.id),
        })) : []
        return { ...product, options: optionWithNumberId }
      }).filter(Boolean) : []

      dispatch({
        type: 'UPDATE_USER_SUCCESS',
        entity: user,
      })
      dispatch({
        type: 'FETCH_VEHICLE_SUCCESS',
        entity: vehicle,
      })
      dispatch({
        type: 'SET_REFI_APPLICATION_DATA',
        payload: {
          vehicleId: vehicle.id,
          refiId: productPackageId,
          userId: user.id,
          refis: {
            currentApplication: { userId: user.id, vehicleId: vehicle.id },
          },
          productPackageId,
        },
      })
      dispatch({
        type: 'CREATE_PRODUCTPACKAGE',
        entity: {
          id: productPackageId,
          products: productsWithNumberId,
          filters,
          addons,
          status,
          discount,
          organization,
          refiDetails,
          basePrice,
          validationDiscountMax,
          firstPaymentMinDays,
          firstPaymentMaxDays,
          firstPaymentMinDate,
          firstPaymentMaxDate,
          monthlyMembershipPosition,
          monthlyMembershipPositionCount,
          monthlyMembershipDiscountable,
          // Carried for the same reason as the monthly membership fields: on a
          // continue-application reload the form reads the ladder position off
          // this entity, and without them Florida resets to position 0 with the
          // Discount button disabled even though the server already stepped.
          floridaMarkupPosition,
          floridaMarkupPositionCount,
          floridaMarkupDiscountable,
          // PaymentDetails seeds the provider select from this, so a reload
          // shows the provider the backend already stored instead of the
          // org default (which Next would then write back over it).
          paymentPlanProviderSource,
          addressNeeded
        },
      })

      if (status === 'quoted') {
        dispatch({
          type: 'GO_TO_COVERAGE_DETAILS_SECTION',
        })
        if (membershipId !== null) {
          dispatch({
            type: 'COVERAGE_DETAILS_NEXT_STEP',
          })
        }
      }
      if (status === 'selected') {
        const selectedProduct = products?.find(
          (product) => Number(product.id) === selectedProductId
        )

        if (selectedProduct && selectedProduct.options) {
          const opt = selectedProduct.options.find(
            (option) =>
              selectedProduct.selectedProductOptionId === Number(option.id)
          )

          dispatch({
            type: 'ADD_PRODUCT_OPTION_STATE',
            payload: { productId: selectedProduct.id, selectedOption: opt },
          })
        }
      }
      if (status === 'selected' || status === 'empty') {
        dispatch({
          type: 'GO_TO_COVERAGE_DETAILS_SECTION',
        })
        dispatch({
          type: 'COVERAGE_DETAILS_NEXT_STEP',
        })
      }
      if (status === 'product_remitted_error') {
        dispatch({
          type: 'GO_TO_COVERAGE_DETAILS_SECTION',
        })
      }

      return Promise.resolve(productPackage)
    })
    .catch(() => {
      dispatch({
        type: 'FETCH_PRODUCTPACKAGE_FAILURE',
      })
      dispatch(
        displayNotification('Failed to fetch PRODUCT_PACKAGES', 'error', 10000)
      )
    })
}

// The first payment window is a snapshot from the last package fetch, and a
// deal left at the payment step on Friday and resumed on Monday would still
// offer Friday's window -- days in the past. Refetch only the window, since
// fetchProductPackage also moves the application between steps. On failure
// the cached window stays and the server's own check rejects a stale date
// (blinker-legacy#47).
export const refreshFirstPaymentWindow = (productPackageId) => (dispatch) => {
  return request(productPackageWindowQuery, { id: productPackageId })
    .then((response) => {
      const {
        firstPaymentMinDays,
        firstPaymentMaxDays,
        firstPaymentMinDate,
        firstPaymentMaxDate,
      } = response.data.data.productPackage

      dispatch({
        type: 'UPDATE_PRODUCTPACKAGE_SUCCESS',
        entity: {
          id: productPackageId,
          firstPaymentMinDays,
          firstPaymentMaxDays,
          firstPaymentMinDate,
          firstPaymentMaxDate,
        },
      })
    })
    .catch(() => undefined)
}
